import type { UserV1 } from '@/shared/api';

export function getPostLoginDestination(
	user: Pick<UserV1, 'subscriptionId' | 'hasPurchasedCourses'> | null,
): '/' | '/problems' | '/courses' {
	if (user?.hasPurchasedCourses) return '/courses';
	if (user?.subscriptionId) return '/problems';
	return '/';
}

export const checkUserPremiumStatus = (user: UserV1): boolean => {
	if (!user) return false;

	// Проверяем наличие активных подписок
	const hasActiveSubscription = user.productsID && user.productsID.length > 0;

	return hasActiveSubscription;
};

export const checkTelegramLinkedStatus = (user: UserV1): boolean => {
	if (!user) return false;

	return Boolean(user.telegram?.id);
};

export function isNeedOnboardingUser(user: UserV1 | null): boolean {
	if (!user) return false;
	return (
		Boolean(user.subscriptionId || user.hasPurchasedCourses) &&
		user.onboarding === false
	);
}

export function getPostOnboardingDestination(
	user: Pick<UserV1, 'hasPurchasedCourses'>,
): '/courses' | '/problems' {
	return user.hasPurchasedCourses ? '/courses' : '/problems';
}
